export default "__VITE_ASSET__Da0znB$Q__"